import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3yqyd5scgp: FaireBrandEntity = {
  token: "b_3yqyd5scgp",
  type: "brand",
  name: "Way Maker Yeg",
  avatarUrl:
    "https://cdn.faire.com/fastly/7008a717b62eb9b210d662402083dc40a2ee6c05b570cd2d97d1a5aefe45b3bc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/25f5da4832c3d60ee6074ff550109c7daf708c6313c6124c02b3fd73ab681b9b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7008a717b62eb9b210d662402083dc40a2ee6c05b570cd2d97d1a5aefe45b3bc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/25f5da4832c3d60ee6074ff550109c7daf708c6313c6124c02b3fd73ab681b9b.png",
  location: "Edmonton , AB, CAN",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    " I'm Julia, the passionate mind behind the scenes at Way Maker. I love creating colorful things from glass cups to tote bags and apparel. We love spreading the word of Jesus in the way that people can wear it with confidence. Our apparels are faith based designs. Way Maker Yeg is based out in Edmonton,Alberta, Canada\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:19.786Z",
    importedBy: "entity-db-cli",
  },
};
